module.exports = __webpack_public_path__ + "static/media/charts-footer-image-2.b325066f.PNG";